module.exports = __webpack_public_path__ + "static/img/16.cd416b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/16.png
// module id = 32d3
// module chunks = 0